/* Card tilt (see assets/evol-card-tilt.css): a [data-evol-tilt] card turns toward the pointer and a
   glare follows it. One delegated listener per page, however many sections render the loader;
   pointer devices only (touch keeps tap-to-enlarge); off for reduced motion. */
(function () {
  if (window.evolCardTilt) return;
  window.evolCardTilt = 1;
  if (matchMedia('(hover: none)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var cur, frame;
  function reset(el) {
    cancelAnimationFrame(frame);
    el.style.removeProperty('--tilt-rx');
    el.style.removeProperty('--tilt-ry');
  }
  document.addEventListener('pointermove', function (e) {
    var el = e.target.closest && e.target.closest('[data-evol-tilt]');
    if (el !== cur) {
      if (cur) reset(cur);
      cur = el;
    }
    if (!el) return;
    var r = el.getBoundingClientRect();
    var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function () {
      el.style.setProperty('--tilt-ry', ((px - 0.5) * 20).toFixed(2) + 'deg');
      el.style.setProperty('--tilt-rx', ((0.5 - py) * 20).toFixed(2) + 'deg');
      el.style.setProperty('--tilt-gx', (px * 100).toFixed(1) + '%');
      el.style.setProperty('--tilt-gy', (py * 100).toFixed(1) + '%');
    });
  }, { passive: true });
  document.addEventListener('pointerout', function (e) {
    if (cur && !cur.contains(e.relatedTarget)) {
      reset(cur);
      cur = null;
    }
  }, { passive: true });
})();
